export const generateConfig = () => window.env
